module.exports = __webpack_public_path__ + "static/media/PC5-3.aec86fd7.jpg";